import { render, staticRenderFns } from "./Bonuses.vue?vue&type=template&id=5a1611d5&scoped=true&"
import script from "./Bonuses.vue?vue&type=script&lang=js&"
export * from "./Bonuses.vue?vue&type=script&lang=js&"
import style0 from "./Bonuses.vue?vue&type=style&index=0&id=5a1611d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1611d5",
  null
  
)

export default component.exports